import * as types from "../types";

const initialState = {
	user: {},
	isLoggedIn: false,
	permissions: [],
};

export const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.LOG_IN:
			let permissions = [];
			action.payload.data.role.permissions.map(permission =>
				permission.permissions.map(singlePermission => {
					return permissions.push(singlePermission.name);
				})
			);
			return {
				...state,
				user: action.payload,
				isLoggedIn: true,
				permissions: permissions,
			};
		case types.LOG_OUT:
			return { ...state, isLoggedIn: false, user: {}, permissions: [] };
		default:
			return state;
	}
};
